module.exports = __webpack_public_path__ + "static/media/2_1.7af35291.png";